var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64867 6.69299H1.63067L9.34667 6.69299L6.92167 9.12099C6.80247 9.24042 6.73553 9.40226 6.73553 9.57099C6.73553 9.73973 6.80247 9.90157 6.92167 10.021L7.29867 10.394C7.41695 10.5119 7.57716 10.5781 7.74417 10.5781C7.91119 10.5781 8.07139 10.5119 8.18967 10.394L12.3477 6.23699C12.4653 6.11795 12.5312 5.95734 12.5312 5.78999C12.5312 5.62264 12.4653 5.46204 12.3477 5.34299L8.18967 1.18399C8.07127 1.06632 7.91111 1.00027 7.74417 1.00027C7.57724 1.00027 7.41708 1.06632 7.29867 1.18399L6.92167 1.56199C6.8631 1.62031 6.81668 1.68968 6.7851 1.76606C6.75351 1.84245 6.73739 1.92434 6.73767 2.00699C6.73739 2.08846 6.75354 2.16915 6.78516 2.24424C6.81677 2.31932 6.8632 2.38726 6.92167 2.44399L9.37467 4.88899L1.64067 4.88899C1.47078 4.89237 1.3089 4.96184 1.1894 5.08264C1.0699 5.20345 1.0022 5.36608 1.00067 5.53599V6.06999C1.00538 6.23808 1.07595 6.39758 1.19717 6.51412C1.31838 6.63065 1.48053 6.6949 1.64867 6.69299Z",
    fill: "#BAC9F5",
    stroke: "#212D4F",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.cef01b99ca759b4306365ec441d176b2.svg";
export { ForwardRef as ReactComponent };